//@flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { Columns } from '@locus-taxy/neo-ui';
import LoginPageWrap from './LoginPageWrap';
import LoginLeftSection from './LoginLeftSection';
import LoginRightSection from './LoginRightSection';

const LoginPage = () => {
    return (
        <LoginPageWrap>
            <Columns align="center" alignY="center" space="64px">
                <LoginLeftSection />
                <LoginRightSection />
            </Columns>
        </LoginPageWrap>
    );
};

export default translate('settings')(LoginPage);
